import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { setCurrentLang } from "@/lib/format";

const LanguageContext = createContext(null);

const DICT = {
  brand: { ar: "رنف لاين", en: "RNF_Line" },
  tagline: { ar: "أناقةٌ تليق بكِ، وتفاصيلٌ تشبهكِ", en: "Elegance that suits you" },
  home: { ar: "الرئيسية", en: "Home" },
  shop: { ar: "التسوّق", en: "Shop" },
  search: { ar: "بحث", en: "Search" },
  cart: { ar: "السلة", en: "Cart" },
  account: { ar: "حسابي", en: "Account" },
  login: { ar: "تسجيل الدخول", en: "Login" },
  logout: { ar: "تسجيل الخروج", en: "Logout" },
  addToCart: { ar: "أضيفي إلى السلة", en: "Add to cart" },
  outOfStock: { ar: "غير متوفر", en: "Out of stock" },
  size: { ar: "المقاس", en: "Size" },
  color: { ar: "اللون", en: "Color" },
  quantity: { ar: "الكمية", en: "Quantity" },
  subtotal: { ar: "المجموع", en: "Subtotal" },
  total: { ar: "الإجمالي", en: "Total" },
  checkout: { ar: "إتمام الطلب", en: "Checkout" },
  emptyCart: { ar: "سلة التسوق فارغة", en: "Your cart is empty" },
  browse: { ar: "تصفّحي المجموعة", en: "Browse collection" },
  featured: { ar: "المجموعة", en: "The Collection" },
  newArrivals: { ar: "وصل حديثاً", en: "New Arrivals" },
  viewAll: { ar: "عرض الكل", en: "View all" },
  description: { ar: "الوصف", en: "Description" },
  code: { ar: "الرمز", en: "SKU" },
  price: { ar: "السعر", en: "Price" },
  searchPlaceholder: { ar: "ابحثي عن عباية…", en: "Search abayas…" },
  noResults: { ar: "لا توجد نتائج", en: "No results" },
  myOrders: { ar: "طلباتي", en: "My orders" },
  testMode: { ar: "وضع تجريبي — الدفع الإلكتروني غير مُفعّل", en: "Test mode — online payment not live" },
  placeOrder: { ar: "تأكيد الطلب (تجريبي)", en: "Place order (test)" },
  name: { ar: "الاسم", en: "Name" },
  phone: { ar: "رقم الهاتف", en: "Phone" },
  note: { ar: "ملاحظة", en: "Note" },
  password: { ar: "كلمة المرور", en: "Password" },
  email: { ar: "البريد الإلكتروني", en: "Email" },
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("rnf_lang") || "ar");
  setCurrentLang(lang);

  useEffect(() => {
    localStorage.setItem("rnf_lang", lang);
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((key) => (DICT[key] ? DICT[key][lang] : key), [lang]);
  const tr = useCallback((ar, en) => (lang === "ar" ? ar : en), [lang]);
  const toggle = () => setLang((l) => (l === "ar" ? "en" : "ar"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t, tr }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
